



































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { BTable } from 'bootstrap-vue';
import { SearchCondition, BaseSheet } from "../../modules/teacher/BaseSheetList"

export interface Data {
  condition: SearchCondition
  baseSheets: BaseSheet[]
  fields: any[]
  currentPage: number
  perPage: number
  isAllDeleteChecked: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      baseSheets: new Array<BaseSheet>(),
      fields: [
        {key: "sheet_code", label: "レポートCD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "レポート名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "field_names_completed_text", label: "設問情報", class: 'text-center b-table-th-td'},
        {key: "corretct_image_completed_text", label: "模範解答", class: 'text-center b-table-th-td'},
        {key: "field_positions_completed_text", label: "枠設定", class: 'text-center b-table-th-td'},
        {key: "answer_image_completed_text", label: "答案PDF", class: 'text-center b-table-th-td'},
        {key: "question_image_completed_text", label: "問題PDF", class: 'text-center b-table-th-td'},
        {key: "part1_image_completed_text", label: "大問Png", class: 'text-center b-table-th-td'},
        {key: "status", label: "状態", class: 'text-center b-table-th-td'},
        {key: "edit", label: "設定", class: 'text-center b-table-th-td'},
      ],
      currentPage: 1,
      perPage: 20,
      isAllDeleteChecked: false,
      errors: [],
    });

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/base_sheet_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.baseSheets = response.data.base_sheet_hashes.map((x: any) => new BaseSheet(x)); 
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * QR生成画面へ
     ******************************/

    const toUpload = (baseSheet: BaseSheet) => {
      context.root.$router.push(`/teacher_site/qr_base_sheet_upload/${baseSheet.id}`).catch(err => {});
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
    });

    return {
      ...toRefs(state),
      tableRef,
      search,
      clearCondition,
      toUpload,
    };
  }
});
